/**
 * alert func
 * AlertDialog.alert(message, callback)
 **/
var AlertDialog = (function ($, o) {
	var $body = $("body");

	var tmpl1 = `<div class="alert-modal-style">
                    <div class="modal-body">
                        <div class="modal-info"></div>
                        <div class="text-center">
                            <a class="btn-close-alert btn btn-secondary w-100" href="#"><span>確定</span></a>
                        </div>
                    </div>
                </div>`;
	var tmpl2 = `<div class="alert-modal-style">
                    <div class="modal-body">
                        <div class="modal-info"></div>
                            <div class="row">
                                <div class="col">
                                    <a id="" class="btn-confirm-alert btn btn-secondary w-100" href="#"><span>確定</span></a>
                                </div>
                                <div class="col">
                                    <a id="" class="btn-cancel-alert btn btn-outline-secondary w-100" href="#"><span>取消</span></a>
                                </div>
                            </div>
                    </div>
                </div>`;
	var tmpl3 = `<div class="alert-modal-style">
                    <div class="modal-body">
                        <div class="modal-info" style="padding-bottom: 0px"></div>
                        
                    </div>
                </div>`;

	var alertInfo = function (msg, tmpl, textAlign, callback, name) {
		var $tmpl = $(tmpl);

		$tmpl.attr("data-name", name == undefined ? "" : name);

		$tmpl.find(".modal-info").html(msg);
		$tmpl.find(".modal-info").addClass(textAlign);

		$body.css({ overflow: "hidden" });
		$body.append($tmpl);

		$(".btn-cancel-alert")
			.unbind()
			.click(function (e) {
				e.preventDefault();
				$(this).parents(".alert-modal-style").remove();
				$body.css({ overflow: "", "padding-right": "" });
			});

		$(".btn-close-alert, .btn-confirm-alert")
			.unbind()
			.click(function (e) {
				e.preventDefault();
				$(this).addClass("disabled");
				$(this).parents(".alert-modal-style").remove();
				$body.css({ overflow: "", "padding-right": "" });
				if (callback == undefined || callback == null) return;
				callback();
			});
	};

	o.alert = function (msg, callback, name) {
		alertInfo(msg, tmpl1, "text-center", callback, name);
	};
	o.confirm = function (msg, callback, name) {
		alertInfo(msg, tmpl2, "text-center", callback, name);
	};
	o.special = function (msg, callback, name) {
		alertInfo(msg, tmpl3, "text-center", callback, name);
	};

	return o;
})($, window.AlertDialog || {});

export default AlertDialog;
